<script lang="ts" setup>
  import type { SelectCustomEvent } from '@ionic/vue'
  import { chevronDown } from 'ionicons/icons'
  import { studentOptions } from '~/constants/profile'

  const props = withDefaults(
    defineProps<{
      label?: string
      name?: string
      studentType: number | null | undefined
    }>(),
    {
      label: 'Are you a student?',
      name: 'studentType'
    }
  )

  const emits = defineEmits<{
    (event: 'change', value?: number | null): void
  }>()

  const inputElement = ref()
  defineExpose({ inputElement })

  const { value, handleChange } = useField(props.name)

  function onChange(event?: SelectCustomEvent) {
    emits('change', event?.target.value)
    handleChange(event?.target.value)
  }
</script>

<template>
  <ion-select
    :toggle-icon="chevronDown"
    class="student-input"
    :label="label"
    label-placement="floating"
    :name="name"
    :value="value ?? studentType"
    @ion-change="onChange"
  >
    <ion-select-option v-for="option in studentOptions" :key="option.id" :value="option.id">
      {{ option.value }}
    </ion-select-option>
  </ion-select>
</template>

<style lang="scss" scoped>
  ion-select::part(label) {
    color: var(--color-text-body);
  }
</style>
